import { render, staticRenderFns } from "./Wp_tb_order_count_detail_page.vue?vue&type=template&id=d178252c&scoped=true&"
import script from "./Wp_tb_order_count_detail_page.vue?vue&type=script&lang=js&"
export * from "./Wp_tb_order_count_detail_page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d178252c",
  null
  
)

export default component.exports